import { useCallback } from 'react';
import type { FC } from 'react';
import { useMediaQuery } from 'react-responsive';
import { BREAKPOINTS } from '@presentation/styles';
import { Card, Modal, ModalCloseButton, SectionText, WhatsappButton } from '..';
import * as Styled from './styled';
import type { PartnerModalProps } from './types';

export * from './types';

export const PartnerModal: FC<PartnerModalProps> = (props) => {
  const { modal, text, title, moreInfo, QRCode, whatsappCta } = props;

  const isMobile = useMediaQuery({ query: `(max-width: ${BREAKPOINTS.phone}px)` });

  const showWhatsappCta = isMobile && !!whatsappCta?.url;
  const showQRCode = !isMobile && !!QRCode;

  const onWhatsAppClickHandler = useCallback(() => {
    if (whatsappCta?.url) {
      window.open(whatsappCta.url, '_blank');
    }
  }, [whatsappCta?.url]);

  return (
    <Modal {...modal}>
      <Card size="small" isModal>
        <ModalCloseButton modal={modal} />
        <Styled.Container>
          <Styled.ModalSectionTitle>{title}</Styled.ModalSectionTitle>
          <Styled.SectionText
            dangerouslySetInnerHTML={{
              __html: text?.replaceAll('<a href=', '<a target="_blank" href='),
            }}
          />
          {showWhatsappCta ? (
            <WhatsappButton
              {...(whatsappCta?.text && { label: whatsappCta.text })}
              size="medium"
              outlined={false}
              onClick={onWhatsAppClickHandler}
              shrink
            />
          ) : null}
          {showQRCode ? <Styled.DekstopImage src={QRCode} alt="scanner le code" /> : null}

          {moreInfo ? (
            <SectionText
              dangerouslySetInnerHTML={{
                __html: moreInfo?.replaceAll('<a href=', '<a target="_blank" href='),
              }}
            />
          ) : null}
        </Styled.Container>
      </Card>
    </Modal>
  );
};
